import styled from 'styled-components';

export const Container = styled.div`
  width: ${({ width }) => width};
  height: ${({ width }) => width};
  border-radius: 50%;
  overflow: hidden;
  background-color: #f0f0f0;
  position: relative;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1.5px solid transparent;

  transition: border-color 0.4s ease;

  &:hover {
    border-color: blue;
    -webkit-font-smoothing: antialiased;
    transform: translateZ(0);
  }
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
`;

export const Hovering = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  font-size: 16px;
  border-radius: 50%;
  gap: 10px;
  flex-direction: column;
  border: 1.5px solid blue;
  -webkit-font-smoothing: antialiased;
  transform: translateZ(50);
  transition:
    border-color 0.4s ease,
    background-color 0.4s ease;

  &:hover {
    background-color: rgba(0, 0, 0, 0.7);
    border-color: darkblue;
  }
`;
